import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=1ffac04a&scoped=true"
import script from "./InfoArea.vue?vue&type=script&lang=js"
export * from "./InfoArea.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/info-area.css?vue&type=style&index=0&id=1ffac04a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffac04a",
  null
  
)

export default component.exports